<template>
  <div class="mb-5">
    <div
      class="v-input desktop v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--single-line v-text-field--solo v-text-field--solo-inverted v-text-field--solo-flat v-text-field--is-booted v-text-field--enclosed"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-input__prepend-inner">
            <div class="v-input__icon v-input__icon--prepend-inner">
              <i
                aria-hidden="true"
                class="v-icon notranslate material-icons theme--light"
                >search</i
              >
            </div>
          </div>
          <div class="v-text-field__slot">
            <input
              type="text"
              class="ctw-input"
              autocomplete="off"
              data-ctw-ino="1"
              placeholder="Search ICD Full Code"
              v-model="searchItem"
            />
          </div>
          <div class="v-input__append-inner" v-if="searchItem.length > 0">
            <div class="v-input__icon v-input__icon--clear">
              <button
                type="button"
                aria-label="clear icon"
                class="v-icon notranslate v-icon--link mdi mdi-close theme--light"
                @click="clear"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ctw-window ctw-p" data-ctw-ino="1"></div>
  </div>
</template>

<script>
import * as ECT from "@whoicd/icd11ect";
export default {
  props: {
    stringProp: String,
  },
  data() {
    return {
      searchItem: "",
      item: "",
    };
  },
  mounted() {
    const mySettings = {
      apiServerUrl: "https://icd11restapi-developer-test.azurewebsites.net",
      autoBind: false,
    };

    const myCallbacks = {
      selectedEntityFunction: (selectedEntity) => {
        this.selectedCode(selectedEntity.code);
        ECT.Handler.clear("1");
      },
    };

    ECT.Handler.configure(mySettings, myCallbacks);
    ECT.Handler.bind("1");
  },

  methods: {
    clear() {
      ECT.Handler.clear("1");
    },

    selectedCode(item) {
      this.$emit("clicked", item);
    },
  },
};
</script>

<style>
.ctw-window .ctwFlexItemPadding {
  padding-left: 20px !important;
}
</style>
